import React from 'react';
import Box, { BoxProps } from './Box';

// Flex is Box with display:flex as the default.
// Replicates molekule Flex (which wraps Box with display:flex).

export type FlexProps = BoxProps;

const Flex = React.forwardRef<HTMLDivElement, FlexProps>((props, _ref) => {
  // display:flex is the default; caller can override with display prop
  return <Box display="flex" {...props} />;
});

Flex.displayName = 'Flex';

export default Flex;
